import http from './http'

const basePath = '/achievement/academicConference'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveAcademicConference(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitAcademicConference(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function updateAcademicConference(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  const res = await http.put(basePath, body)
  return res.data
}

export async function getAcademicConferenceById(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function deleteAcademicConference(id) {
  const res = await http.delete(withId(id))
  return res.data
}

export async function listAcademicConference(params) {
  const res = await http.get(basePath, { params })
  return res.data
}
